module.exports = __webpack_public_path__ + "img/PB_Small_Logo.3783785.png";